import React from 'react'
import { createContext, useState} from 'react'
import { v4 as uuidv4 } from 'uuid'

const FeedbackContext = createContext()

export const FeedbackProvider = ({children}) => {

    const [feedback, setFeedback] = useState([
        {
            id:1,
            text: "This is from context 1",
            rating: 10
        },
        {
            id: 2,
            text: "This is from context 2",
            rating: 9
        },
        {
            id:3,
            text: "This is from context 3",
            rating: 7
        }
    ])

    const [feedbackEdit, setFeedbackEdit] = useState({ 
        item: {},
        edit: false
    })

    //Add new Feedback
    const addFeedback = (newFeedback) => {
        newFeedback.id = uuidv4()
        setFeedback([newFeedback, ...feedback])
    }

    //Deleting a Feedback
    const deleteFeedback = (id) => {
        if(window.confirm('Are you sure you want to delete?')){
            setFeedback(feedback.filter((item) => item.id !== id))
        }
    }
    //Updating a Feedback
    const updateFeedback = (id, upItem) => {
        setFeedback(feedback.map((item) => (item.id === id ? {
            ...item, ...upItem} : item))
        )

        console.log(id,upItem)
    }

    //Set item to be updated
    const editFeedback = (item)=> {
        setFeedbackEdit({
            item,
            edit: true
        })
        
    }


    return <FeedbackContext.Provider value={{
        feedback,
        feedbackEdit,
        addFeedback,
        deleteFeedback,
        editFeedback,
        updateFeedback,
        
        
    }}>
        {children}
    </FeedbackContext.Provider>
} 

export default FeedbackContext